export function isWebsiteLive(website: Website) {
  const { stackStatus } = website
  return stackStatus === 'Live'
}
